import styled from 'styled-components';
import {
  alignItems,
  flexbox,
  flexDirection,
  justifyContent
} from '../../styles/helpers/flexbox';

export const StudentAccessWrapper = styled.div``;

export const AccessSwitchWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('space-between')};

  width: 203px;
  height: 32px;
  margin-top: 3px;  
  background-color: #ffbe39;
  color: ${colours.grey[900]};

  cursor: pointer;
  box-sizing: border-box;
  border-radius: 2px;
`;
});

export const Title = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('center')};

  font-size: 13px;
  border-right: 1px solid rgba(0, 0, 0, 0.25);
  width: calc(100% - 27px);
  height: 100%;
`;

export const IconWrapper = styled.div`
  ${flexbox()};
  ${justifyContent('center')};
  padding: 0 5px;
  width: 25px;
`;

export const RestrictedWrapper = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};
    ${flexDirection('row')};
    cursor: pointer;
    padding: 10px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
    background-color: #ffbe39;
    color: ${colours.grey[800]}
  `;
});

export const Heading = styled.div`
  font-size: 11.5px;
  font-weight: 600;
`;

export const Description = styled.div`
  font-size: 11px;
`;
export const DescriptionStrong = styled.div`
  font-weight: 700;
  display: inline;
`;

export const DescriptionWrapper = styled.div`
  width: 80%;
  font-size: 11px;
`;

export const IconUnrestricted = styled.div((props) => {
  const { colours } = props.theme;

  return `
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('center')};

  border: 1px solid ${colours.custom[800]};
  border-radius: 5px;
  width: 25px;
  height: 25px;
  margin: 5px 3px;
  padding: 3px;
`;
});

export const IconContainer = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('center')};

  margin-left: 3px;
`;



// WEBPACK FOOTER //
// ./components/student-access/styled.js